var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.originList.length > 1)?_c('v-autocomplete',{attrs:{"disabled":_vm.disabledView,"items":_vm.originList,"label":"Sucursal de Origen","data-vv-name":"select"},on:{"change":_vm.updateItem},model:{value:(_vm.originId),callback:function ($$v) {_vm.originId=$$v},expression:"originId"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }